import { useState, useEffect } from 'react';
import type { InsightObjectAttribute } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute.tsx';
import { AttributeTypeMap } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute-types.tsx';
import type { CmdbObjectAttribute } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';
import type { ReferencedObjectPickerOption } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/picker-options.tsx';

export const getObjectReferenceOptions = (
	attribute?: InsightObjectAttribute,
): ReferencedObjectPickerOption[] => {
	if (attribute && attribute.type === 'object') {
		return attribute.objectTypeValues.map(
			({ referencedObject: { id, objectKey, label, avatar } }) => ({
				id,
				value: objectKey,
				label,
				avatar,
				objectKey,
			}),
		);
	}
	return [];
};

export const getObjectReferenceOptionsFromCmdbObjectAttribute = (
	attribute?: CmdbObjectAttribute,
): ReferencedObjectPickerOption[] => {
	if (attribute && attribute.type === AttributeTypeMap.Object) {
		return attribute.objectAttributeValues.map(
			({ referencedObject: { objectKey, label, avatar, objectId, workspaceId } }) => {
				const obejectOptionAvatar = { ...avatar, objectId, workspaceId };
				return {
					id: objectId,
					value: objectKey,
					label,
					avatar: obejectOptionAvatar,
					objectKey,
				};
			},
		);
	}
	return [];
};

export const useReferencedObjects = (attribute?: InsightObjectAttribute) => {
	const [value, setValue] = useState<ReferencedObjectPickerOption[]>(
		getObjectReferenceOptions(attribute),
	);

	useEffect(() => {
		setValue(() => getObjectReferenceOptions(attribute));
	}, [attribute]);

	return [value, setValue] as const;
};
